/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-extraneous-dependencies
import 'chartjs-adapter-date-fns';

import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	TimeScale,
} from 'chart.js';
import {Line} from 'react-chartjs-2';
import {useRef} from 'react';

import type {IDataChart, LegendItem} from 'interfaces';
import {COLORS} from 'constants/colors';
import CardBasic from 'components/Cards/Basic';

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	TimeScale,
);

export interface DataSets {
	label: string;
	data: number[];
	backgroundColor: string;
	borderColor: string;
	borderWidth: number;
	pointRadius: number;
	pointHitRadius: number;
	showLine: boolean;
	yAxisID: string;
}

type TProps = {
	labels: string[];
	data: IDataChart[];
	titleCard: string;
	id: string;
	animation?: boolean;
};

const LinearChart = ({
	labels,
	data,
	titleCard = '',
	id,
	animation = false,
}: TProps) => {
	const chartRef = useRef<ChartJS>(null);

	const dataSetsMap = data?.map((d: IDataChart, key: number) => ({
		label: d?.title,
		data: d?.values,
		backgroundColor: 'transparent',
		borderColor: COLORS[key],
		borderWidth: 1,
		pointRadius: 0,
		pointHitRadius: 0,
		showLine: true,
		yAxisID: 'y',
	}));

	const dataSets = {
		labels,
		datasets: dataSetsMap,
	};

	const min = new Date(labels[0]);
	const max = new Date(labels[labels.length - 1]);

	const options = {
		maintainAspectRatio: false,
		responsive: true,
		animation,
		showLines: true,
		interaction: {
			mode: 'index' as const,
			intersect: false,
		},
		stacked: false,
		plugins: {
			legend: {
				position: 'bottom',
				display: true,
				labels: {
					color: '#4D4D4D',
				},
				onClick: (e: any, legendItem: LegendItem) => {
					const chart = e.chart;

					const index = legendItem.datasetIndex;
					const ci = chart;
					const alreadyHidden =
						ci.getDatasetMeta(index).hidden === null
							? false
							: ci.getDatasetMeta(index).hidden;

					dataSets.datasets.forEach(function (er: DataSets, i: number) {
						const meta = ci.getDatasetMeta(i);

						if (i !== index) {
							if (!alreadyHidden) {
								meta.hidden = meta.hidden === null ? !meta.hidden : null;
							} else if (meta.hidden === null) {
								meta.hidden = false;
							}
						} else if (i === index) {
							meta.hidden = null;
						}

						// meta.hidden = true;
					});
				},
			},
			title: {
				display: false,
			},
		},
		scales: {
			y: {
				type: 'linear' as const,
				display: true,
				position: 'left' as const,
			},
			x: {
				type: 'time',
				time: {
					min: min as never,
					max: max as never,
					unit: 'minute',
					unitStepSize: 1,
					displayFormats: {minute: 'h:mm'},
				},
				title: {
					display: false,
				},
			},
		},
	};

	const handleShow = () => {
		const chart = chartRef.current;
		if (chart) {
			dataSets.datasets.forEach(function (_: DataSets, i: number) {
				const meta = chart.getDatasetMeta(i);
				meta.hidden = false;
			});
		}
	};

	if (chartRef && chartRef?.current) {
		// chartRef?.current.update('none');
		// chartRef.current.chartInstance.destroy();
	}

	return (
		<CardBasic title={titleCard} onShow={handleShow}>
			<Line
				ref={chartRef as never}
				id={id}
				options={options as never}
				data={dataSets}
				height={300}
			/>
		</CardBasic>
	);
};

export default LinearChart;
